import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractEntityService } from '@app/shared/abstract/abstract-entity.service';
import { EventTimelineItemModel } from '@app/events/shared/event-timeline-item.model';

@Injectable({
  providedIn: 'root',
})
export class EventTimelineItemService extends AbstractEntityService<EventTimelineItemModel> {
  constructor(http: HttpClient) {
    super('/api/event-timeline-items', http);
  }
}
